export type ViewportTypeLabel = "xs" | "s" | "m" | "ml" | "l" | "xl";

export const Viewport: Record<ViewportTypeLabel, number> = {
  xs: 320,
  s: 360,
  m: 560,
  ml: 768,
  l: 960,
  xl: 1280,
};
